// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 58 ? "quill" : chunkId) + "." + {"19":"1721cf0150480ddb","58":"68cc633bc143fcdb","979":"829f8187b933df87"}[chunkId] + ".js";
};